import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Skipforward"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.75001 21C3.33579 21 3.00001 20.6642 3.00001 20.25V3.74999C2.99894 3.48098 3.14203 3.232 3.37501 3.09749C3.60706 2.96352 3.89296 2.96352 4.12501 3.09749L18.375 11.3475C18.61 11.4807 18.7552 11.7299 18.7552 12C18.7552 12.2701 18.61 12.5193 18.375 12.6525L4.12501 20.9025C4.0107 20.9673 3.88139 21.0009 3.75001 21ZM4.50001 5.04749V18.9525L16.5 12L4.50001 5.04749ZM21 2.99999H22.5V21H21V2.99999Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Skipforward.vue"]]);
